import { Plural } from '@lingui/react/macro';
import classNames from 'classnames';
import React from 'react';
import UDIcon from 'ud-ui/components/icon';
import TeamLogo from 'ud-ui/components/team-logo';
import UDText from 'ud-ui/components/text';
import { DivProps } from 'typings';
import { ChampionshipTeamCardHeaderRow } from './styles';

interface ChampionshipTeamCardHeaderProps {
  teamName: string;
  shortName?: string;
  teamLogo?: string;
  playersCount?: number;
  isExpanded: boolean;
  onExpandClick?: () => void;
  containerProps?: Omit<DivProps, 'children'>;
  prefixComponent?: JSX.Element;
  actions?: JSX.Element;
}

const ChampionshipTeamCardHeader = (props: ChampionshipTeamCardHeaderProps) => {
  const { teamName, shortName, teamLogo, playersCount, isExpanded, onExpandClick, containerProps, prefixComponent, actions } = props;

  const hasPlayersCount = playersCount !== undefined;
  const count = playersCount ?? 0;

  return (
    <ChampionshipTeamCardHeaderRow
      {...containerProps}
      className={classNames('championship-team-card-header', { expanded: isExpanded }, containerProps?.className)}
    >
      <div className="team-info">
        {onExpandClick && (
          <div className="team-card-expand-btn" onClick={onExpandClick}>
            <UDIcon name="down-indicator" />
          </div>
        )}

        {prefixComponent}

        <TeamLogo className="team-logo mr-2" url={teamLogo} size={52} />

        <UDText type="subhead" className="bold">
          {teamName} {shortName ? `(${shortName})` : ''}
        </UDText>
      </div>
      {hasPlayersCount && (
        <UDText type="subhead" className="team-players-count">
          <Plural value={count} one="# игрок" few="# игрока" many="# игроков" other="# игрока" />
        </UDText>
      )}
      {actions}
    </ChampionshipTeamCardHeaderRow>
  );
};

export default ChampionshipTeamCardHeader;
